<div *ngIf="resourcesForm" [formGroup]="resourcesForm">
  <div class="row mb-2 justify-content-end">
    <div class="d-grid col-12 col-md-6 col-lg-3">
      <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="fillIncomes()" [disabled]="disabled">Remplir</button>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-12">
      <table class="table">
        <caption>
          <small *ngIf="submitted && incomesHaveRequiredError()" class="form-text text-danger">Les revenus sont obligatoires</small>
        </caption>
        <thead>
          <tr>
            <th class="w-40"></th>
            <th class="w-20 fw-normal">Mois M-1</th>
            <th class="w-20 fw-normal">Mois M</th>
            <th class="w-20 fw-normal">Mois M+1</th>
            <th class="w-20 fw-normal">Mois M+2</th>
            <th class="w-20 fw-normal">Mois M+3</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><label class="required">Revenus professionnels</label></td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="professionnalIncomePrev"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.professionnalIncomePrev?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="professionnalIncomeCurr"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.professionnalIncomeCurr?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="professionnalIncomeNext"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.professionnalIncomeNext?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="professionnalIncomeNextTwo"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.professionnalIncomeNextTwo?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>

            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="professionnalIncomeNextThree"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.professionnalIncomeNextThree?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="required"><label class="required">Revenus de remplacement</label></td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="replacementIncomePrev"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.replacementIncomePrev?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="replacementIncomeCurr"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.replacementIncomeCurr?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="replacementIncomeNext"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.replacementIncomeNext?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="replacementIncomeNextTwo"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.replacementIncomeNextTwo?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="replacementIncomeNextThree"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.replacementIncomeNextThree?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="required">
              <label class="required">Revenus de stages / formation</label>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="trainingIncomePrev"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.trainingIncomePrev?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="trainingIncomeCurr"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.trainingIncomeCurr?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="trainingIncomeNext"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.trainingIncomeNext?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="trainingIncomeNextTwo"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.trainingIncomeNextTwo?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="trainingIncomeNextThree"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.trainingIncomeNextThree?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="required"><label class="required">Autres Aides sociales</label></td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="socialIncomePrev"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.socialIncomePrev?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="socialIncomeCurr"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.socialIncomeCurr?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="socialIncomeNext"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.socialIncomeNext?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="socialIncomeNextTwo"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.socialIncomeNextTwo?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="socialIncomeNextThree"
                  appInputNumbersOnly
                  [class.is-invalid]="submitted && resourcesForm.controls?.socialIncomeNextThree?.errors"
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td><small>Autre : Précisez</small><input type="text" class="form-control" formControlName="otherIncomePrecision" /></td>
            <td class="align-bottom">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="otherIncomePrev"
                  appInputNumbersOnly
                  [class.is-invalid]="
                    submitted && resourcesForm.errors?.otherIncomeRequired && [null, ''].includes(resourcesForm.controls.otherIncomePrev.value)
                  "
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td class="align-bottom">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="otherIncomeCurr"
                  appInputNumbersOnly
                  [class.is-invalid]="
                    submitted && resourcesForm.errors?.otherIncomeRequired && [null, ''].includes(resourcesForm.controls.otherIncomeCurr.value)
                  "
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td class="align-bottom">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="otherIncomeNext"
                  appInputNumbersOnly
                  [class.is-invalid]="
                    submitted && resourcesForm.errors?.otherIncomeRequired && [null, ''].includes(resourcesForm.controls.otherIncomeNext.value)
                  "
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td class="align-bottom">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="otherIncomeNextTwo"
                  appInputNumbersOnly
                  [class.is-invalid]="
                    submitted && resourcesForm.errors?.otherIncomeRequired && [null, ''].includes(resourcesForm.controls.otherIncomeNextTwo.value)
                  "
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td class="align-bottom">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="otherIncomeNextThree"
                  appInputNumbersOnly
                  [class.is-invalid]="
                    submitted && resourcesForm.errors?.otherIncomeRequired && [null, ''].includes(resourcesForm.controls.otherIncomeNextThree.value)
                  "
                />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <div class="input-group">
                <input type="text" class="form-control" value="{{ getPreviousMonthTotal() }}" disabled />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input type="text" class="form-control" value="{{ getCurrentMonthTotal() }}" disabled />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input type="text" class="form-control" value="{{ getNextMonthTotal() }}" disabled />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input type="text" class="form-control" value="{{ getNextTwoMonthTotal() }}" disabled />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
            <td>
              <div class="input-group">
                <input type="text" class="form-control" value="{{ getNextThreeMonthTotal() }}" disabled />
                <span class="input-group-append d-none d-lg-block input-group-text">€</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-12 mb-3">
      <div class="form-check">
        <input
          id="withoutSolidarityPlan"
          type="checkbox"
          class="form-check-input"
          formControlName="withoutSolidarityPlan"
          name="withoutSolidarityPlan"
          [class.is-invalid]="submitted && resourcesForm.controls.withoutSolidarityPlan.invalid"
        />
        <label for="withoutSolidarityPlan" class="form-check-label"
          ><strong
            >Je déclare ne pas bénéficier du Revenu de Solidarité Active, ni de Allocation Adulte Handicapé, ni Allocation d'Éducation de l'Enfant
            Handicapé</strong
          ><span class="text-danger"> *</span></label
        >
        <small *ngIf="submitted && resourcesForm.controls.withoutSolidarityPlan.errors?.required" class="form-text text-danger"
          >Ce champ est requis.</small
        >
      </div>
    </div>
    <div class="col-12 col-lg-12 mb-3">
      <div class="form-check">
        <input
          id="withoutYouthPlan"
          type="checkbox"
          class="form-check-input"
          formControlName="withoutYouthPlan"
          name="withoutYouthPlan"
          [class.is-invalid]="submitted && resourcesForm.controls.withoutYouthPlan.invalid"
        />
        <label for="withoutYouthPlan" class="form-check-label"
          ><strong>Je déclare ne pas bénéficier d'un Contrat d'Engagement Jeune ou d’un Contrat Jeune Majeur le mois suivant la demande</strong
          ><span class="text-danger"> *</span>
        </label>
        <small *ngIf="submitted && resourcesForm.controls.withoutYouthPlan.errors?.required" class="form-text text-danger"
          >Ce champ est requis.</small
        >
      </div>
    </div>
  </div>
</div>
